import React, { useEffect, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { Typography } from '@material-ui/core'

import Accordion from '_/components/accordion'
import { ControlledRating } from '_/views/manage-providers/components/RatingComponent'
import useRolePermission from '_hooks/use-role-permission'
import { RATE_FIELDS, RATE_LABEL_FIELDS } from '_views/provider/constants'
import Theme from '@refera/ui-core'
import { InfoCircle } from '@refera/ui-icons'

import useStyles from './styles'

const ProviderMetrics = () => {
  const styles = useStyles()
  const { watch, setValue } = useFormContext()
  const { isSAAS } = useRolePermission()

  const agencyAvg = watch('agency_average_rate')
  const generalAvg = watch('general_average_rate')

  const updateNestedValues = useCallback(
    (prefix, data) => {
      if (!data) return
      RATE_FIELDS.forEach(field => {
        setValue(`${prefix}.${field}`, data?.[field] ?? 0)
      })
    },
    [setValue]
  )

  useEffect(
    () => updateNestedValues('agency_average_rate', agencyAvg),
    [agencyAvg, updateNestedValues]
  )
  useEffect(
    () => updateNestedValues('general_average_rate', generalAvg),
    [generalAvg, updateNestedValues]
  )

  const renderRatings = useCallback(
    (prefix, label) => (
      <div className={styles.column}>
        <span className={styles.label}>{label}</span>
        {RATE_FIELDS.map(field => (
          <ControlledRating
            key={`${prefix}.${field}`}
            className={styles.rate}
            name={`${prefix}.${field}`}
            label={RATE_LABEL_FIELDS[field]}
            disabled
          />
        ))}
      </div>
    ),
    [styles.column, styles.label, styles.rate]
  )

  return (
    <Accordion title="Métricas" className={styles.accordion}>
      {isSAAS && renderRatings('agency_average_rate', 'Minha avaliação')}
      {renderRatings('general_average_rate', 'Avaliação de imobiliárias')}

      <div className={styles.infoText}>
        <InfoCircle color={Theme.Colors.Primary.Base} fontSize={12} />
        <Typography style={{ textAlign: 'left', lineHeight: '2.5rem', fontSize: '10px' }}>
          Para editar acesse &quot;Minha avaliação&quot; na tela de gestão de prestadores
        </Typography>
      </div>
    </Accordion>
  )
}

export default ProviderMetrics
